import { render, staticRenderFns } from "./datastore-dialog.vue?vue&type=template&id=2bbc7f86&scoped=true&"
import script from "./datastore-dialog.vue?vue&type=script&lang=js&"
export * from "./datastore-dialog.vue?vue&type=script&lang=js&"
import style0 from "./datastore-dialog.vue?vue&type=style&index=0&id=2bbc7f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc7f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VProgressLinear,VRow,VTooltip})
